import QualityBarColumn, { cellType, qualityBarColumnConfiguration } from './QualityBarColumn.component';

export { cellType, QualityBarColumn };
export default qualityBarColumnConfiguration;
